export default () => ({
  items: [],
  pagination: [],
  item: {}
})
